import { FunctionalComponent, h } from "preact"
import { useContext, useEffect, useState } from "preact/hooks";
import { ContentPageServiceContext } from "@authentic/loyalty-pwa/providers";
import { ContentPageResponse } from "@authentic/loyalty-pwa/interfaces";
import { PageNotFound } from "../PageNotFound";

export const ContentPage: FunctionalComponent = (props) => {
  const contentPageService = useContext(ContentPageServiceContext);
  const [content, setContent] = useState(<div></div>)
  const queryParams: any = props;
  let url = queryParams.url;
  if (process.env.CONTEXT_PATH)
    url = queryParams.url.substring(process.env.CONTEXT_PATH.length + 1);
  const slug = url.replace(/\//g, "");

  useEffect(() => {
    contentPageService?.getContentPageBySlug(slug)
      .then((res: ContentPageResponse) => {
        if (res.success && res.data?.url) {
          // res.data.url is a external url configured from loyalty platform
          window.location.href = res.data.url;
        } else {
          // when the resource is available but the url field is missing then redirect to 404 page
          setContent(<PageNotFound />)
        }
      });
  }, [slug]);

  return content
}